const locale = {
  placeholder: 'Chá»n thá»i gian',
};

export default locale;
